import { BillTypeEnum } from '../../../enums/BillTypeEnum'

const BillCard: React.FC<BillInterface> = ({ model }) => {
  return (
    <div className='shadow-inner rounded-sm bg-disable/10 backdrop-blur-md grid grid-cols-1  px-3'>
      <div
        className='flex justify-between items-center text-xs font-bold py-2 border-b
       border-b-disable'
      >
        <h2>
          {`${BillTypeEnum[model.billType]} (${model.billId})`.toPersian()}
        </h2>
        <span>{model.billTypeName}</span>
      </div>
      <div className='flex justify-between text-xs py-2  '>
        <div>{`تاریخ : ${model.billCycle.substring(
          0,
          4
        )}/${model.billCycle.substring(4, 2)}`}</div>
        <div>
          <span className='text-xs font-bold'>
            {`جمع کل سهم سازمان : ${model.detail
              .reduce((partialSum, a) => partialSum + a.orgPart, 0)
              .currency()}`.toPersian()}
          </span>
        </div>
      </div>
      <div className='flex gap-2 font-bold text-xs  py-2 border-b border-dotted border-b-disable'>
        <span>توضیحات : </span>
        <p className=''>{model.description ?? 'خالی'}</p>
      </div>
      <div className='flex flex-col '>
        {model.detail.map((n, i) => (
          <div
            key={i}
            className='flex flex-col gap-2 shadow-inner my-2 bg-white/80 backdrop-blur-sm py-4 px-2'
          >
            <div
              className='flex justify-between items-center font-bold text-sm text-primary border-b
             border-b-primaryDefault2  py-2 px-1'
            >
              <span>{n.productName}</span>
              <span>
                {n.type === 'Visit'
                  ? 'ویزیت'
                  : n.type === 'Service'
                  ? 'ریز نسخه'
                  : 'نامشخص'}
              </span>
            </div>
            <div className='py-2 flex justify-around items-center text-xs text-secondaryDark'>
              <span className=''>
                {n.specialAccount === 'N'
                  ? 'بیماری خاص نیست'
                  : 'بیماری خاص هست'}
              </span>
              <span>{`تعداد : ${n.count}`}</span>
              <span>{`سهم سازمان : ${n.orgPart.currency()}`.toPersian()}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default BillCard
